import { Component, Prop, Vue } from "vue-property-decorator";
import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";
import { Module } from "@/store/enums.ts";
import RadioTable from "@/components/RadioTable.tsx";
import { db, userDataCollection } from "@/firebase";
import { updateStudentScoring } from "@/service/DashboardBackend";

@Component
export default class BalliAbility extends Vue {
  completed = false;
  private _questions: [{ question: string; answer: number; qid: number }];
  private introCompleted: boolean = false;

  constructor() {
    super();
    this._questions = this.$store.getters.balliQuestions.ability;
  }

  beforeCreate() {
    this._questions = this.$store.getters.balliQuestions.ability;
    this.introCompleted = false;
  }

  hasCompleted(completed: boolean) {
    this.completed = completed;
  }

  submit() {
    var thisUser = this.$store.getters.user;
    var uid = thisUser.data.uid;

    if (this.$store.getters.balliSections[1].progress != 100) {
      updateStudentScoring();
      let timepoint = this.$store.getters.balliTimepointStr;
      // Store the responses
      userDataCollection
        .doc(uid)
        .collection("balli")
        .doc(timepoint)
        .collection("responses")
        .doc("ability")
        .set({ Answers: this._questions })
        .then(function() {
          userDataCollection
            .doc(uid)
            .collection("balli")
            .doc(timepoint)
            .update({
              "completionStatus.ability": {
                status: true,
                dateCompleted: Date.now()
              }
            });
        })
        .catch(function(error) {
          //console.error("Error writing responses for Balli Ability: ", error);
        });

      // Update progress in $store
      this.$store.commit("markBalliComplete", "Ability");
      this.$store.commit("progressBalli", this._questions.length);
    }

    // Move to Attitude
    this.$router.push({ name: "balliAttitude" });
  }

  stateLoaded() {
    return this.$store.getters.balliQuestionsLoaded;
  }

  private introScreen() {
    return (
      <Card>
        <div slot="mainContent">
          <span class="subtitle-1">Let's talk about how well you learn.</span>
        </div>
        <div slot="actions">
          <v-btn
            color="primary"
            onClick={() => {
              this.introCompleted = true;
              this.$forceUpdate();
            }}
          >
            Next
          </v-btn>
        </div>
        <div slot="progressBar">
          <v-spacer></v-spacer>
          <v-progress-linear
            value={Math.round(
              (this.$store.getters.progressBalli /
                this.$store.getters.numBalliQuestions) *
                100
            )}
            height="4"
            opacity="0.3"
            striped={true}
          ></v-progress-linear>
        </div>
      </Card>
    );
  }

  render(h: CreateElement) {
    if (!this.introCompleted) {
      return this.introScreen();
    }

    return (
      this.stateLoaded() && (
        <Card
          title="Think about your reading and writing ability in class. Does this sound like you?"
          mod={Module.BALLI}
        >
          <v-form ref="form" slot="mainContent" id="radioForm">
            <RadioTable
              questions={this._questions}
              onUpdate={this.hasCompleted}
              fixHeader={true}
              disabled={this.$store.getters.balliSections[1].progress == 100}
              labelType={this.$store.getters.balliRadioHeader}
            ></RadioTable>
          </v-form>
          <div slot="actions">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              disabled={!this.completed}
              onClick={this.submit}
            >
              Next
            </v-btn>
          </div>
          <div slot="progressBar">
            <v-spacer></v-spacer>
            <v-progress-linear
              value={Math.round(
                (this.$store.getters.progressBalli /
                  this.$store.getters.numBalliQuestions) *
                  100
              )}
              height="4"
              opacity="0.3"
              striped={true}
            ></v-progress-linear>
          </div>
        </Card>
      )
    );
  }
}

const component = BalliAbility;
